import { IconButton } from "@mui/material";

const CustomIconButton = ({
  onClick,
  size,
  autoFocus,
  disabled,
  iconColor,
  bgcolor,
  href,
  icon,
  imgStyle,
  img,
  sx,
  hideBgcolor
}) => {

  return (
    <IconButton
      href={href}
      sx={{
        "&:hover": {
          bgcolor: bgcolor ? bgcolor : hideBgcolor ? "transparent" : "primary.main",
        },
        bgcolor: bgcolor ? bgcolor : hideBgcolor ? "transparent" : "primary.main",
        width: size ?? 50,
        height: size ?? 50,
        borderRadius: 2,
        opacity: disabled ? 0.1 : 1,
        ...sx
      }}
      target={href ? "_blank" : null}
      color={iconColor ?? "primary.text"}
      onClick={onClick && !disabled ? onClick : () => { }}
      autoFocus={autoFocus ? true : false}
    >
      {icon ? icon : null}
      {img ? <img src={img} style={imgStyle} /> : null}
    </IconButton>
  );
};
export default CustomIconButton;
